<template>
  <w-textarea :model="schema.comment" />
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz komentarza akcji przycisku
// @group ActionData
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
